export default "__VITE_ASSET__XwQZv0Su__"